import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/seo";
import { GlossaryOverviewPage } from "@/components/calv/glossary/GlossaryOverviewPage";

export const Route = createFileRoute("/en/glossary/")({
  head: () => {
    const h = pageHead("glossary", "en");
    return { meta: h.meta, links: h.links };
  },
  component: () => <GlossaryOverviewPage locale="en" />,
});
